/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Paginator } from 'primereact/paginator'

import back from '../assets/images/back.svg'

function CompanyListComponent({ companyList, getCompanyByPage, totalRecords, isCompanyLoading }) {
  const [start, setStart] = useState(0)
  const [search, setSearch] = useState('')
  const [showLoader, setShowLoader] = useState(true)
  const history = useHistory()
  const pageSize = 20
  useEffect(() => {
    setShowLoader(true)
    getCompanyByPage(0, 20, '', null, null, 'name')
  }, [getCompanyByPage, setShowLoader])
  useEffect(() => {
    setShowLoader(false)
  }, [companyList])
  const companyBlocks = () => {
    return companyList.map(function (c) {
      return (<div className="p-col-3" key={c.companyId}>
        <span key={c.companyId} onClick={() => history.push('/dashboard/view-company/' + c.companyId)}>
          {c.name ? <div title={c.name.length > 50 ? c.name : ''}>{c.name.length > 50 ? (c.name.slice(0, 50) + '..') : c.name}</div> : ''}
        </span>
      </div>)
    })
  }
  const searchByName = () => {
    history.push('/dashboard/company-list/search/' + search)
  }
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const onEnterKeySearch = (event) => {
    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()
    }
  }
  const onPageChange = (event) => {
    setStart(event.first)
    // console.log(event)
    getCompanyByPage(event.page, pageSize, search, null, null, 'name')
  }
  const BackClick = () => {
    history.goBack()
  }
  return (
    <div className="addSector fullWidth">
      {showLoader && <div className="overlay">
        <div className="lds-ripple"><div></div><div></div></div>
      </div>}
      <Card >
        <div className="titleCon m-b-20">
          <p className="title flex">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />COMPANIES
          </p>
          <div className="p-inputgroup customSearch">
            <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
            <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
          </div>
        </div>
        {companyList.length > 0 ?
          <>
            <div className="p-grid p-fluid companyCon">
              {companyBlocks()}

            </div>
            <div className="p-col-12">
              <Paginator first={start} rows={pageSize} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator>
            </div>
          </> : <div className="p-grid p-fluid companyCon">{!isCompanyLoading && <div className="p-col-12">No Companies Found</div>}</div>
        }

      </Card>
    </div>
  )
}
CompanyListComponent.propTypes = {
  companyList: PropTypes.array,
  getCompanyByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  isCompanyLoading: PropTypes.bool
}
export default CompanyListComponent
